import { BaseTicketController } from '../../../../common/base/ticketController';
import rgbHex from 'rgb-hex';

import _ from 'lodash';

import { DOWNLOAD_PAYMENT_PARTNER_OVERVIEW_EVENT } from '../../ticket.controller';

const TrackingEvents = {
  submit: 'Submit Confirm',
};

export class ConfirmController extends BaseTicketController {
  constructor(
    controllerService,
    $scope,
    ticketService,
    cardService,
    fdFormFieldsService,
    ReceivingKwhTypes,
    isPasswordRequired,
    notificationService,
    needsConfirmationService,
    trackingService,
    pdfViewerService,
    ticketsService,
    confirmService,
  ) {
    'ngInject';
    super({
      controllerService,
      $scope,
      ticketService,
      cardService,
      fdFormFieldsService,
      ReceivingKwhTypes,
      isPasswordRequired,
      notificationService,
      needsConfirmationService,
      trackingService,
      pdfViewerService,
      ticketsService,
      confirmService,
    });

    this.additionalData = {};
  }

  get featureSetPackagePasswordInSubmitWarrantState() {
    return this.isFeatureActive(
      this.FeatureNames.FF_SET_PACKAGE_PASSWORD_IN_SUBMIT_WARRANT_STATE,
    );
  }

  get featureHidePackagePasswordOnPaymentPartnerState() {
    return this.isFeatureActive(
      this.FeatureNames.FF_HIDE_PACKAGE_PASSWORD_ON_PAYMENT_PARTNER_STATE,
    );
  }

  get showPasswordSection() {
    return (
      this.ticket.email &&
      // last possibilty to set a password if not already present on warrant form
      !this.featureSetPackagePasswordInSubmitWarrantState &&
      // force hide the password section regardless of tickets flow (rb austria for example)
      !this.featureHidePackagePasswordOnPaymentPartnerState
    );
  }

  get featureAddNewPaymentPartner() {
    return this.isFeatureActive(this.FeatureNames.FF_ADD_NEW_PAYMENT_PARTNER);
  }

  get featureConfirmSubmit() {
    return this.isFeatureActive(
      this.FeatureNames.FF_CONFIRM_PAYMENT_PARTNER_SUBMIT,
    );
  }

  get signatureEnabled() {
    return this.isFeatureActive(
      this.FeatureNames.FF_SIGNATURE_PAYMENT_PARTNER_STATE,
    );
  }

  get financeData() {
    const { cardService, data } = this;

    // Prepare payment partners for the finance request
    // WARNING: data.partners i have no idea why this was partners before...
    const finances = cardService.prepareDataForRequest(data.cards);

    // Check for given signature and add it to the additional data
    if (this.shouldCaptureSignature) {
      this.additionalData.signature = this.getSignature();
    }

    // Add additional data (e.g. user submitted password) to the finance data
    return _.merge({ finances }, this.additionalData);
  }

  get shouldCaptureSignature() {
    return this.signatureEnabled && this.signatureRequired;
  }

  get signatureRequired() {
    return (
      !this.ticket.ticket.signatureCaptured ||
      !this.ticket.ticket.acceptedSignatureUsageForSEPA
    );
  }

  get showMusterWritingsNotification() {
    return this.ticket.formValues.sendCustomerMusterWriting;
  }

  get acceptDebitsCertainSpecialPaymentPartnerListMultiplier() {
    return this.ticket.formValues
      .acceptDebitsCertainSpecialPaymentPartnerListMultiplier;
  }

  getActiveCards(cards) {
    return _.filter(cards, (card) => !card.removable.removed).length;
  }

  $onInit() {
    super.$onInit();

    this.appName = 'KWH Service';
    // Start tracking timing for this state
    this.trackingService.userTimings(TrackingEvents.submit);

    // Set additional account owners as contracting partners (affiliate)
    this.setAccountOwnersAsPartners();

    if (this.noConfirmationNeeded()) {
      this.ticketService.viewStatusChanged(this.ticket.id, {
        reason: 'noConfirmationNeeded',
        icon: 'fa-check',
      });
    }

    // Initialize card removed flag and notification handler
    this.initCardRemovedNotification();

    this.appService.subscribe(
      DOWNLOAD_PAYMENT_PARTNER_OVERVIEW_EVENT,
      this.$scope,
      () => {
        this.downloadPaymentPartnerOverviewDocument();
      },
    );

    // TODO do this right
    if (this.signatureEnabled) {
      let environment = '';
      if (!this.envService.isProduction()) {
        if (this.envService.isDevelopment() || this.envService.isLocalhost()) {
          environment = '.dev';
        } else {
          if (this.envService.isTesting()) {
            environment = '.test';
          }
        }
      }

      // TODO move this to config.json
      this.mobileSignUrl = `https://sign${environment}.fino.cloud/`;
      this.signatureServiceUrl = `https://sign${environment}.fino.cloud/api/v0/`;

      const primaryColor = this.config.ui.primaryColor.startsWith('rgb')
        ? `#${rgbHex(this.config.ui.primaryColor)}`
        : this.config.ui.primaryColor;

      this.signatureTheme = encodeURIComponent(
        /* eslint-disable-next-line */
        JSON.stringify({
          primaryColor,
          logo: this.config.ui.navbar.brandLogo,
        }),
      );
    }
  }

  setAccountOwnersAsPartners() {
    const owners = this.ticket.formValues.additionalAccountOwners;
    if (owners) {
      owners.map((partner) => {
        this.cardService.addContractingPartner(partner);
      });
    }
  }

  noConfirmationNeeded() {
    const { ticket, ReceivingKwhTypes, userService } = this;
    return (
      ticket.guidanceType &&
      ticket.guidanceType.toLowerCase() === ReceivingKwhTypes.ONLINE &&
      !userService.hasRole(userService.Roles.Guest)
    );
  }

  initCardRemovedNotification() {
    this.isAtLeastOneCardRemoved = false;
    _.forEach(this.data.cards, (cards) => {
      _.forEach(cards, (elements) => {
        let onRemove = elements.removable.onRemove;
        elements.removable.onRemove = (isRemoved) => {
          onRemove(isRemoved);
          if (isRemoved && !this.isAtLeastOneCardRemoved) {
            this.isAtLeastOneCardRemoved = true;
            this.notificationService.warning(
              'app.confirm.removed.info.body',
              null,
              'app.confirm.removed.info.title',
            );
          }
        };
      });
    });
  }

  passwordValid() {
    if (!this.passwordForm) {
      return true;
    }
    this.passwordForm.$submitted = true;
    return this.passwordForm.$valid;
  }

  passwordChanged(checked, password) {
    if (!checked) {
      delete this.additionalData.password;
      return;
    }
    this.additionalData.password = password;
  }

  getSignature() {
    if (this.signature && !this.signature.isEmpty) {
      return this.signature.dataUrl;
    }
    // No or empty signature
    return null;
  }

  buffer() {
    this.ticketService
      .bufferFinances(this.ticket.id, this.financeData)
      .busy(this, 'isBufferBusy');
  }

  submit() {
    this.dataInvalid = !this.dataValid();
    if (this.dataInvalid) {
      return;
    }

    const data = this.prepareFinances(this.financeData);

    const financesValid = this.financesValid(data.finances);
    const passwordValid = this.passwordValid();

    if (
      !this.showDialogIfNoPaymentPartnerSelected(
        financesValid,
        passwordValid,
        data,
      )
    ) {
      this.valdidateAndSendForm(financesValid, passwordValid, data);
    }
  }

  dataValid() {
    return this.cardService.allCardsValid();
  }

  prepareFinances(financeData) {
    return this.confirmService.prepareFinances(financeData);
  }

  isDirectDebitsSection(section) {
    return (
      section == 'directDebits' &&
      _.size(this.acceptDebitsCertainSpecialPaymentPartnerListMultiplier) > 0
    );
  }

  financesValid(finances) {
    // Check for empty finance data and track that happening
    const { directDebits, receivedPayments } = finances;
    if (
      directDebits &&
      directDebits.length === 0 &&
      receivedPayments &&
      receivedPayments.length === 0
    ) {
      this.errorTrackingService.captureMessage('Submit empty finance data');
      // TODO/DISCUSS prevent submit when finances data not $valid
      // return false;
    }
    return true;
  }

  showDialogIfNoPaymentPartnerSelected(financesValid, passwordValid, data) {
    let isAtLeastOnePaymentPartnerNotIgnoredOnPrint = data.finances.directDebits
      .concat(data.finances.receivedPayments)
      .some((e) => {
        // if only one is false not all are deselected.
        return !e.ignoreOnPrint;
      });

    if (!isAtLeastOnePaymentPartnerNotIgnoredOnPrint) {
      // prepare confirmation dialog
      _.defaults(this.$scope, {
        confirmTitle: 'component.confirm.modal.title',
        confirmBody: 'component.confirm.modal.body',
        confirmDismiss: 'component.confirm.modal.dismiss',
        confirmOk: 'component.confirm.modal.confirm',
      });

      // show dialog uiModalDeclarationService
      this.needsConfirmationService.open({
        onSuccess: () => {
          this.valdidateAndSendForm(financesValid, passwordValid, data);
        },
        scope: this.$scope,
      });
    }

    return !isAtLeastOnePaymentPartnerNotIgnoredOnPrint;
  }

  downloadPaymentPartnerOverviewDocument() {
    const data = this.confirmService.getPaymentPartnerOverviewData(
      this.financeData,
    );

    this.ticketsService
      .downloadPaymentPartnerOverviewDocument(this.ticket.id, data)
      .then((base64String) => {
        this.downloadingPreviewOfAccountswitchDatesProtocol = false;
        const url = this.pdfViewerService.makeBase64Downloadable(base64String);
        this.pdfViewerService.downloadIt(url, 'ÜbersichtZahlungspartner.pdf');
      });
  }

  valdidateAndSendForm(financesValid, passwordValid, data) {
    if (financesValid && passwordValid) {
      this.fdFormFieldsService.validate(this.confirmSubmitForm).then(() => {
        this.$log.debug({ data });
        this.ticketService
          .putFinancesConfirm(this.ticket.id, data)
          .busy(this, 'isSubmitBusy')
          .then(() => {
            // Track the elapsed time between the onEnter time-event of this state and its submit
            let paymentPartnerStats =
              this.confirmService.getPaymentPartnerStatisticsFromFinances(
                data.finances,
              );

            this.trackingService.eventTrack(
              TrackingEvents.submit,
              _.assign(
                {
                  ticketId: this.ticket.id,
                },
                paymentPartnerStats,
              ),
            );
          });
      });
    }
  }

  addCard(type) {
    // Ignore this method call if the feature to add new cards is disabled
    if (!this.featureAddNewPaymentPartner) {
      return;
    }

    const { cardService } = this;

    if (!this.financeData.finances[type]) {
      this.financeData.finances[type] = [];
    }

    const ticketId = this.ticket.id;

    // Set index for new card at last position
    const index = this.financeData.finances[type].length;
    const card = cardService.createCard(type, ticketId, index, {
      isAdded: true,
      iconClass: 'asterisk',
    });

    // Add card model to partners
    if (!this.data.partners[type]) {
      this.data.partners[type] = [];
    }
    this.data.partners[type].unshift(card);

    const cardBuilt = cardService.buildPaymentPartnerCard(card);
    cardService.openCard(cardBuilt);

    // TODO save the partner (we need an endpoint for this!)
    // Add card representation to cards
    this.data.cards[type].unshift(cardBuilt);
  }

  $onDestroy() {
    this.cardService.clearContractingPartners();
  }
}
